import clsx from "clsx";
import { ArrowUpRightIcon, UsersIcon } from "lucide-react";
import { useNavigate } from "react-router";

import { useGetJobsWithPartialCandidacyCountsByStatus } from "@/hooks/queries";
import { CandidacyStatus, JobStatus } from "@/types";
import {
  candidacyStatusToBackgroundColor,
  candidacyStatusToLabel,
} from "@/lib/constants";

export const DashboardPipelineActivity = ({
  className,
}: {
  className?: string;
}) => {
  const { data: jobsWithPartialCandidacyCountsByStatus, status } =
    useGetJobsWithPartialCandidacyCountsByStatus({
      jobStatuses: [JobStatus.ACTIVE],
    });
  const navigate = useNavigate();

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  } else if (status === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <div className={clsx("rounded-lg border border-slate-200", className)}>
      <div className="flex flex-col gap-[6px] border-b border-slate-200 p-6 pb-4">
        <div className="flex items-center gap-2">
          <UsersIcon className="h-5 w-5 text-slate-900" />
          <p className="text-xl font-semibold text-slate-900">
            Pipeline Activity
          </p>
        </div>
        <p className="text-sm text-slate-500">
          Your job pipelines that are currently active
        </p>
      </div>
      {/* TODO: Way to not need to keep them in sync. */}
      {/* IMPORTANT: This max height needs to be kept in sync with `<DashboardActiveJobs>` */}
      <div className="flex max-h-[444px] flex-col overflow-y-auto">
        {jobsWithPartialCandidacyCountsByStatus.map(
          ({ job, partialCountsByCandidacyStatus }, i) => {
            return (
              <div
                className={clsx(
                  "flex w-full cursor-pointer items-center justify-between px-6 py-4 hover:bg-slate-100",
                  i > 0 && "border-t border-slate-200",
                )}
                key={job.id}
                onClick={() => {
                  void navigate(`jobs/${job.id}/pipeline`);
                }}
              >
                <div className="flex flex-col gap-2">
                  <p className="font-medium text-slate-900">{job.title}</p>
                  <div className="flex">
                    {[
                      CandidacyStatus.MATCHED,
                      CandidacyStatus.INTERVIEW,
                      CandidacyStatus.OFFER,
                    ].map((candidacyStatus, j) => {
                      return (
                        <div
                          className={clsx(
                            "flex items-center gap-[3px] border-l border-slate-200 px-2",
                            j === 0 && "border-none pl-0",
                          )}
                          key={candidacyStatus}
                        >
                          <p className="text-xs font-medium text-slate-700">
                            {candidacyStatusToLabel[candidacyStatus]}
                          </p>
                          <div
                            className={clsx(
                              "h-[6px] w-[6px] rounded-full",
                              candidacyStatusToBackgroundColor[candidacyStatus],
                            )}
                          />
                          <p className="text-xs font-medium text-slate-700">
                            {/* @ts-expect-error - We know that `candidacyStatus` will be a key of `partialCountsByCandidacyStatus`. */}
                            {partialCountsByCandidacyStatus[candidacyStatus]}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <ArrowUpRightIcon className="h-4 w-4 text-slate-700" />
              </div>
            );
          },
        )}
      </div>
    </div>
  );
};
